import React from 'react';
import { useTable } from 'react-table';
import { Link } from 'react-router-dom';
import {ImageIllustration} from "../../Image/ImageIllustration";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faExclamation,
    faExclamationCircle,
    faExternalLink, faPlus,
    faRemove,
    faTrash, faXmark
} from "@fortawesome/free-solid-svg-icons";
import ReactTableBase from "../../Table/ReactTableBase";
import AxiosConfig from "../../../services/AxiosConfig";
import {useModal} from "../../../contexts/ModalContext";
import {getSeanceStatusIcon, parseSeanceStatus} from "../../../services/SeanceService";
import {getUtilisateurStatusIcon, parseUtilisateurStatus} from "../../../services/UserService";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import {Field, Formik} from "formik";
import RenderCellActif from "../../Table/RenderCellActif";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";
import ParticipantCreation from "../Participants/ParticipantCreation";

const SeancesTable = ({ seances, putActifOpenModal = null, handleSubmitSeanceStatus = null, serverSideSorting = false, onSortChange, initialSortBy }) => {
    const data = React.useMemo(() => seances, [seances]);
    const {showModal, hideModal} = useModal();

    const renderCellId = ({ row, value }) => {
        return <Link to={ Routing.generate({route: Routing.routes.adminSeanceDirect, params: {seanceId: row.original.id}}) }>{value}</Link>;
    }

    const renderCellEntreprise = ({ row }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminEntreprise,
            params: {entrepriseId: row.original.entreprise.id}}
        )}>{row.original.entreprise.nom}</Link>;
    }

    const renderCellCreated = ({ value }) => {
        if (!value) return;
        return DateService.formatDate(value);
    }

    const renderCellDate = ({ value }) => {
        if (!value) return;
        return DateService.formatDate(value);
    }

    const ouvrirModalParticipant = (original) => {
        showModal('classic', {
            children: (
                <ParticipantCreation
                    entreprise={original.entreprise}
                    contrat={original.contrat}
                    activite={original.activite}
                    seance={original}
                    onSuccess={({seance, nb, asuId}) => {
                        hideModal();
                        data.forEach(s => {
                            if (s.id === seance) {
                                s.placesReservees = s.placesReservees + nb;
                            }
                        });
                    }}
                />
            )
        });
    };


    const renderCellActions = ({ row }) => {
        const params = {
            entrepriseId: row.original.entreprise.id,
            contratId: row.original.contrat.id,
            activiteId: row.original.activite.id,
            seanceId: row.original.id
        };

        return (
            <div className={styles.actions}>
                <Link to={ Routing.generate({route: Routing.routes.adminSeance, params}) }>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Détail
                </Link>

                <Link to={Routing.generate({route: Routing.routes.adminSeance, params, queryParams: {mode: "creation"}})}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Modifier
                </Link>
                <Link to={Routing.generate({route: Routing.routes.adminSeanceParticipations, params})}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Participants
                </Link>

                <button className={"btn btn_primary"} style={{ padding: "2px 4px"}} onClick={() => ouvrirModalParticipant(row.original)}>
                    <FontAwesomeIcon icon={faPlus}/>
                    Ajouter un participant
                </button>

                <button className={"btn btn_primary"} style={{ padding: "2px 4px"}} onClick={() => putActifOpenModal(row.original)}>
                    <FontAwesomeIcon icon={faXmark}/>
                    Supprimer
                </button>
            </div>
        );
    }

    const renderCellCoach = ({ value }) => {
        return (
            <>
            { value.absent === true ? <FontAwesomeIcon icon={faExclamationCircle} color={"var(--clr-danger)"} title={"Une absence à été signalée"}/> : null }
                <Link to={Routing.generate({route: Routing.routes.adminUtilisateur, params: {utilisateurId: value.id}})}>{value.prenom} {value.nom}</Link>
            </>)
    }

    const renderCellType = ({ row, value }) => {
        return <Link to={Routing.generate({route: Routing.routes.adminActiviteType, params: {activiteTypeId: value.id}})}
                     style={{
                         // color: value.clr_font,
                         // backgroundColor: value.clr_bg,
                         padding: "5px 10px",
                     }}>
            {value.label}
        </Link>;
    }

    const renderCellStatus = ({ value, row }) => {
        return (
            <>
                <Formik
                    initialValues={{ status: value ?? "", id: row.original.id }}
                    onSubmit={handleSubmitSeanceStatus}
                    enableReinitialize
                >
                    {({isSubmitting, setFieldValue, values, submitForm}) => {
                        const handleChange = (e) => {
                            const { name, value } = e.target;
                            setFieldValue(name, value, false);
                            submitForm();
                        };

                        return (
                            <div className={styles.selectContainer}>
                                {getSeanceStatusIcon(value)}
                                <Field as="select" name="status" onChange={handleChange} className={styles.select}>
                                    <option>
                                        -- Sélectionnez un statut --
                                    </option>
                                    <option value={"1"}>
                                        Actif
                                    </option>
                                    <option value={"2"}>
                                        Validé
                                    </option>
                                    <option value={"3"}>
                                        Annulé
                                    </option>
                                </Field>
                            </div>
                        );
                    }
                    }
                </Formik>
            </>
        );
    }

    const renderCellPlaces = ({ row, value }) => {
        return `${ value } / ${row.original.participantsMax}`;
    }

    const columns = [
        /*{
            Header: 'Id',
            accessor: 'id',
            Cell: renderCellId,
        },*/
        {
            Header: 'Logo',
            accessor: 'type.logo',
            Cell: ({ value, row }) => <Link to={Routing.generate({route: Routing.routes.adminSeance, params: {
                    entrepriseId: row.original.entreprise.id,
                    contratId: row.original.contrat.id,
                    activiteId: row.original.activite.id,
                    seanceId: row.original.id
                }})}>
                <ImageIllustration src={value} alt={"logo"} openImage={false}/>
            </Link>
        },
        {
            Header: 'Type',
            accessor: 'type',
            Cell: renderCellType,
        },
        {
            Header: 'Entreprise',
            accessor: 'entreprise',
            Cell: renderCellEntreprise,
        },
        {
            Header: 'Coach',
            accessor: 'coach',
            Cell: renderCellCoach,
        },
        {
            Header: 'Date',
            accessor: 'date',
            Cell: renderCellDate,
        },
        {
            Header: 'Durée',
            accessor: 'duree',
        },
        {
            Header: 'Places',
            accessor: 'placesReservees',
            Cell: renderCellPlaces
        },
        {
            Header: 'Statut',
            accessor: 'status',
            Cell: renderCellStatus,
        },
        {
            Header: 'État',
            accessor: 'actif',
            isBoolean: true,
            Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
        },
        {
            Header: 'Actions',
            id: 'actions',
            Cell: renderCellActions,
        },
    ];

    return (
        <ReactTableBase
            dataSource={seances}
            columnsData={columns}
            serverSideSorting={serverSideSorting}
            onSortChange={onSortChange}
            initialSortBy={initialSortBy}
        />
    );
};

export default SeancesTable;
